import { datadogRum } from '@datadog/browser-rum';

import { environment } from '@env/environment';

export function datadogInit() {
  if (environment.datadog.clientToken && environment.datadog.applicationId) {
    datadogRum.onReady(() => {
      datadogRum.init({
        clientToken: environment.datadog.clientToken,
        applicationId: environment.datadog.applicationId,
        site: 'datadoghq.com',
        service: environment.datadog.service,
        env: environment.datadog.env,
        version: environment.version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 10,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: (event) => {
          event.view.url = stripAuthParams(event.view.url);
          if (event.view.referrer) {
            event.view.referrer = stripAuthParams(event.view.referrer);
          }
          return true;
        },
      });
    });
  }
}

export function stripAuthParams(url: string): string {
  try {
    const parsed = new URL(url);
    parsed.searchParams.delete('token');
    parsed.searchParams.delete('refreshToken');

    return parsed.toString();
  } catch {
    return url;
  }
}
